import {Col, Row, Tag, Tooltip, Typography} from "antd";
import React from "react";
import {useCourierOnboarding} from "hooks/useCourierOnboarding";
import {CourierRequestSelection} from "../CourierRequestSelection/CourierRequestSelection";
import {courierRequestCourierApprovalStatues, managerCompanyOptions} from "constants/constants";
import {PoppingTag} from "./CourierInfoRow.styles";
export const CourierInfoRow = ({courier, isMobile, reloadCourier = () => {}}) => {
    const {renderOnboardingStatus, renderOnboardingSubStatus} = useCourierOnboarding();
    const activityColors = {
        active: "#377c02",
        inactive: "#ff0f00"
    };

    const onboardingStatusColors = {
        candidate: "#fe8207",
        blocked: "#ff0f00",
        isRejected: "#ff0f00",
        approved: "#377c02"
    };

    const managerCompanyColors = {
        agency: "magenta",
        vigo: "geekblue"
    };

    return (
        <Row>
            <div>
                <Typography.Title level={5}>{courier.fullname}</Typography.Title>
            </div>
            <div style={{marginLeft: isMobile ? "0" : "16px"}}>
                <Tooltip title="Kurye Aktiflik Durumu">
                    <Tag
                        color={activityColors[courier?.disabled ? "inactive" : "active"]}
                        style={{marginRight: "4px"}}
                    >
                        {courier?.disabled ? "Pasif" : "Aktif"}
                    </Tag>
                </Tooltip>
                <Tooltip title="Kurye Durumu">
                    <Tag
                        color={onboardingStatusColors?.[courier?.activationStep]}
                        style={{marginRight: "4px"}}
                    >
                        {renderOnboardingStatus({
                            activationStep: courier.activationStep
                        })}
                    </Tag>
                </Tooltip>

                <Tooltip title="İşe Alım Durumu">
                    <Tag style={{marginRight: "4px"}}>
                        {renderOnboardingSubStatus({
                            activationSubStep: courier.activationSubStep,
                            activationStep: courier.activationStep
                        })}
                    </Tag>
                </Tooltip>
                <Tooltip title="Adli Sicil Kaydı">
                    <Tag style={{marginRight: "4px"}}>
                        {courier?.hasCriminalRecord
                            ? "Adli Sicil Kaydı Var"
                            : "Adli Sicil Kaydı Yok"}
                    </Tag>
                </Tooltip>
                <Tooltip title="Yönetici Firma">
                    {courier?.managerCompany ? (
                        <Tag
                            color={managerCompanyColors[courier.managerCompany]}
                            style={{marginRight: "4px"}}
                        >
                            {
                                managerCompanyOptions.find(o => o.value === courier.managerCompany)
                                    ?.name
                            }
                        </Tag>
                    ) : (
                        <PoppingTag color="volcano" style={{marginRight: "4px"}}>
                            Yönetici Firma Belirlenmedi
                        </PoppingTag>
                    )}
                </Tooltip>
                {!!courier ? (
                    <Tooltip title="Kurye Talebi">
                        {courier?.courierRequestInfo?.courierRequestId &&
                        courier?.courierRequestInfo?.requestApproveStatus ===
                            courierRequestCourierApprovalStatues.APPROVED ? (
                            <Tag style={{marginRight: "4px"}}>{courier?.courierRequest?.name}</Tag>
                        ) : (
                            <CourierRequestSelection courier={courier} callbackFn={reloadCourier} />
                        )}
                    </Tooltip>
                ) : (
                    <></>
                )}
            </div>
        </Row>
    );
};
